import * as React from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Button from '@mui/material/Button';
import { routes } from '../Routes';
import { useTranslation } from 'react-i18next';
import { useApp } from '../hooks/useApp';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';

interface IErrorPageProps {
  message?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    noPadding: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
    },
    banner: {
      textAlign: 'center',
      marginBottom: 15,
      paddingTop: 15,
      paddingBottom: 15,
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
    mtContainer: {
      marginTop: 119,
    },
    whiteButton: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
    },
  })
);

const ErrorPage: React.FC<IErrorPageProps> = ({ message }): JSX.Element => {
  const { t } = useTranslation();
  const { app } = useApp();
  const classes = useStyles({});

  return (
    <>
      {!app.isLoading() && (
        <>
          <div className={`${classes.noPadding} ${classes.banner}`}>
            <ErrorOutlineIcon
              style={{
                fontSize: '74px',
              }}
            />
          </div>
          <Container
            component='main'
            maxWidth='xs'
            className={classes.mtContainer}
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography>
                  {message ? (
                    <p>{message}</p>
                  ) : (
                    <>
                      <p>{message || t('error_404.message_1')}</p>
                      <p>{message || t('error_404.message_2')}</p>
                    </>
                  )}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Button
                  type='submit'
                  fullWidth
                  variant='contained'
                  className={classes.whiteButton}
                  onClick={() => window.location.reload()}
                >
                  {t('error.page.try.again')}
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  type='submit'
                  fullWidth
                  variant='contained'
                  className={classes.whiteButton}
                  onClick={() => window.location.replace(routes.home)}
                >
                  {t('error.page.go.home')}
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  type='submit'
                  fullWidth
                  variant='contained'
                  color='secondary'
                  onClick={() =>
                    window.location.replace(routes.prefix + routes.login)
                  }
                >
                  {t('error.page.login')}
                </Button>
              </Grid>
            </Grid>
          </Container>
        </>
      )}
    </>
  );
};

export default ErrorPage;
